var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditIconWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.654,
    height: 15.632,
    viewBox: "0 0 15.654 15.632",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_67880",
    "data-name": "Path 67880",
    d: "M16.262.775,6.207,10.829A4.1,4.1,0,0,0,5,13.744v1.108a.825.825,0,0,0,.825.825H6.932a4.1,4.1,0,0,0,2.915-1.207L19.9,4.415a2.577,2.577,0,0,0,0-3.64,2.634,2.634,0,0,0-3.64,0Zm2.474,2.474L8.681,13.3a2.49,2.49,0,0,1-1.749.724H6.649v-.283A2.49,2.49,0,0,1,7.373,12L17.428,1.941a.947.947,0,0,1,1.308,0,.926.926,0,0,1,0,1.308Z",
    transform: "translate(-5 -0.045)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconWhite);
export default __webpack_public_path__ + "static/media/edit-icon-white.73890bb0f198be5fbae23cd08da120c7.svg";
export { ForwardRef as ReactComponent };